import { useContext, useMemo } from "react";
import { toolbarButtonGroupContext } from "../ToolbarButtonGroupContext.js";
function useToolbarButtonGroup() {
  const labelsContext = useContext(toolbarButtonGroupContext);
  if (labelsContext === void 0) throw new Error("useToolbarButtonGroup requires a ToolbarButtonGroup ancestor.");
  return useMemo(() => ({ showLabels: labelsContext }), [labelsContext]);
}
export {
  useToolbarButtonGroup
};
//# sourceMappingURL=useToolbarButtonGroup.js.map
